/**
 * Numeric amount from scope-of-work costOverride (API may use price, value, or amount).
 */
export function parseCostOverrideAmount(raw: unknown): number | null {
  if (raw == null || raw === "") return null;
  if (typeof raw === "number" && Number.isFinite(raw) && raw > 0) return raw;
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (!trimmed) return null;
    try {
      const co = JSON.parse(trimmed) as Record<string, unknown>;
      const v = Number(co.price ?? co.value ?? co.amount ?? 0);
      return Number.isFinite(v) && v > 0 ? v : null;
    } catch {
      const n = Number(trimmed);
      return Number.isFinite(n) && n > 0 ? n : null;
    }
  }
  if (typeof raw === "object") {
    const co = raw as { price?: unknown; value?: unknown; amount?: unknown };
    const v = Number(co.price ?? co.value ?? co.amount ?? 0);
    return Number.isFinite(v) && v > 0 ? v : null;
  }
  return null;
}
